module.exports = __webpack_public_path__ + "img/实训室.ba31ac03.png";